import type { IPathBaseParam } from "./path";

import { createPostApi } from "@api/util/createPostApi";
import type { IApiResponse } from "@/api";
import type { IContactMessageRespondDto } from "@api/contactMessages/respond/types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IContactMessageRespondDto
>("contactMessages.respond");

export const respond = {
  ...postApis,
};
